import FollowUpAgenciamentoConsultPageBase from './FollowUpAgenciamentoConsultPageBase';
import { FOLLOWUP_FILTROS } from '../followUpAgenciamentoFixedFilters';

export default function FollowUpAgenciamentoConsultImportMaritimoPage(props) {
  return (
    <FollowUpAgenciamentoConsultPageBase
      {...props}
      filtrosFixos={FOLLOWUP_FILTROS.IMPORT_MARITIMO}
      urlNovo="/importacao/agenciamento/maritimo/follow-up/registro/novo"
      urlDetalhes={(id) => `/importacao/agenciamento/maritimo/follow-up/${id}/detalhes`}
      urlLista={(id) => `/importacao/agenciamento/maritimo/follow-up/${id}/lista`}
      breadcrumbModulo={{
        name: 'Importação Agenciamento Marítimo',
        to: '/importacao/agenciamento/maritimo',
      }}
    />
  );
}
